import React from 'react';
import AdminLayout from '../../../components/Layout/AdminLayout';
import WorkerPerformance from './WorkerPerformance';

function action({ store }) {
  const isAdminAuthenticated = store.getState().runtime.isAdminAuthenticated;
  if (!isAdminAuthenticated) {
    return { redirect: '/login' };
  }
  return {
    title: 'Worker Performance | Admin',
    component: (
      <AdminLayout>
        <WorkerPerformance />
      </AdminLayout>
    ),
  };
}

export default action;
